import { render, staticRenderFns } from "./UpdateUser.vue?vue&type=template&id=61a8203b&scoped=true&"
import script from "./UpdateUser.vue?vue&type=script&lang=js&"
export * from "./UpdateUser.vue?vue&type=script&lang=js&"
import style0 from "./UpdateUser.vue?vue&type=style&index=0&id=61a8203b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a8203b",
  null
  
)

export default component.exports